import travelBook from '@images/photobooks/travelbookBanner.jpg';
import travelBookMobile from '@images/photobooks/travelbookBannerMobile.jpg';

export const bannerContent = [
  {
    key: '1',
    title: 'Фотокнига о путешествии',
    rank: 1,
    showOnMobile: false,
    url: '/products/photobooks/travelbook/',
    image: {
      localFile: {
        photo: travelBook,
      },
    },
    mobileImage: {
      localFile: {
        photo: travelBookMobile,
      },
    },
  },
];
